:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.subcategory-block__main {
  padding: 15px;
}

@media screen and (min-width: 980px) {
  .subcategory-block__main {
    padding: 30px 40px;
  }
}

.subcategory-block__collapser-wrapper {
  display: flex;
  justify-content: center;
  border-top: 1px solid #e6e6e6;
}

@media screen and (min-width: 980px) {
  .subcategory-block__collapser-wrapper {
    padding: 4px 40px;
  }
}

.subcategory-block__ranges {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

@media screen and (min-width: 980px) {
  .subcategory-block__ranges {
    flex-direction: row;
    max-width: 100%;
  }
}

.subcategory-block__range-card {
  padding: 20px 5px;
}

@media screen and (min-width: 980px) {
  .subcategory-block__range-card {
    width: calc(33.33% - 16.66px);
  }

  :host(:not([dir="rtl"])) .subcategory-block__range-card {
    margin-right: 25px;
  }

  :host([dir="rtl"]) .subcategory-block__range-card {
    margin-left: 25px;
  }

  :host(:not([dir="rtl"])) .subcategory-block__range-card:nth-child(3n) {
    margin-right: 0;
  }

  :host([dir="rtl"]) .subcategory-block__range-card:nth-child(3n) {
    margin-left: 0;
  }
}

.subcategory-block__promo-banner {
  padding: 20px 5px;
  flex: 1 0 auto;
}

.subcategory-block__description {
  display: block;
  margin-bottom: 16px;
}

.subcategory-block__ranges-title {
  margin: 0;
  color: #333333;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.5625rem;
}

@media screen and (min-width: 980px) {
  .subcategory-block__ranges-title {
    font-size: 1.375rem;
    line-height: 1.875rem;
  }
}

.subcategory-block__ranges-count {
  color: #9fa0a6;
  cursor: default;
}